





























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
@Component({
    components: {},
})
export default class ItemList extends Vue {
    @Prop()
    addButton!: string;
    @Prop()
    minItems!: number;
    @Prop()
    maxItems!: number;
    @Prop()
    icon!: string;
    @Prop()
    initialAmmount!: number;
    @Prop({ default: false })
    divider!: boolean;

    isFormComplete: number = 0;
    oldItems: any[] = Array();
    items: string[] = Array();
    key: number = 0;

    $refs!: {
        item: any;
    };

    selectedValues: any[] = Array();

    mounted() {
        for (let i = 0; i < this.initialAmmount; i++) {
            this.addItem();
        }
    }

    deleteItem(index: number) {
        this.oldItems.splice(index, 1);
        this.items.splice(index, 1);
        this.$emit('itemDeleted', index);
    }

    addItem() {
        this.items.push('Item' + this.key++);
    }

    requestData() {
        this.isFormComplete++;
    }

    setOldItems(oldItems: any[]) {
        for (let i = 0 + this.initialAmmount; i < oldItems.length; i++) {
            this.addItem();
        }
        this.oldItems = oldItems;
    }

    setSelectedValues(selectedValues: any[]) {
        this.selectedValues = selectedValues;
    }

    @Watch('items')
    emitItemLength(value: number, oldValue: number) {
        this.$emit('itemsLength', this.items.length);
    }
}
